import { useEffect, useState, useLayoutEffect } from 'react';
import { ChartData, ChartOptions } from 'chart.js';
import { useTranslation } from 'react-i18next';
import { Chart } from 'primereact/chart';

export interface GraphStepsDistributionProps {
  data: ChartData;
  options: ChartOptions;
  model?: number;
}

export function GraphStepsDistribution(props: GraphStepsDistributionProps) {
  const { i18n } = useTranslation();

  const [chartData, setChartData] = useState<ChartData>(props.data);
  const [chartOptions, setChartOptions] = useState<ChartOptions>(props.options);
  const [resizeKey, setResizeKey] = useState(0);

  useEffect(() => {
    setChartData(props.data);
    setChartOptions(props.options);
  }, [i18n.language, props.data, props.options]);

  useLayoutEffect(() => {
    const handleResize = () => {
      setResizeKey((prev) => prev + 1);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Chart key={resizeKey} type="pie" data={chartData} options={chartOptions} />
  );
}

export default GraphStepsDistribution;
